import { ClockCircleOutlined, MailOutlined } from '@ant-design/icons';
import { OmniaVideo } from '@omniafishing/core';
import { Button, Form, Input } from 'antd';
import dayjs from 'dayjs';
import React from 'react';
import { useDispatch } from 'react-redux';
import useIsMounted from '../../hooks/use_is_mounted';
import { useRudderstack } from '../../hooks/use_rudderstack';
import { apiV1 } from '../../lib/api';
import { FlashMessageActions } from '../../redux/flash_message';
import styles from './stream_has_not_started.less';

export const StreamHasNotStarted = ({ omnia_video }: { omnia_video: OmniaVideo }) => {
  const { title, summary, thumbnail, event_start, livestream } = omnia_video;
  const dispatch = useDispatch();
  const [form] = Form.useForm();
  const isMounted = useIsMounted();
  const { anonymousId } = useRudderstack();
  const eventStartDayjs = dayjs(event_start);
  const now = dayjs();
  const hasNotStartedYet = livestream && now.isBefore(eventStartDayjs);

  return (
    <>
      {hasNotStartedYet && (
        <section className={styles.notStartedSection}>
          <div className={styles.notStartedHeader}>
            <div className={styles.eventStart}>
              <ClockCircleOutlined />
              Event starts {eventStartDayjs.format('MMMM D, YYYY')} at{' '}
              {eventStartDayjs.format(isMounted() ? 'h:mma z' : 'h:mma')}
            </div>

            <div>
              <Form
                form={form}
                className={styles.notifyForm}
                onFinish={(values) => {
                  apiV1
                    .eventTrack('Live Stream Notify', anonymousId, {
                      notify_email: values.email,
                    })
                    .then(() => {
                      dispatch(
                        FlashMessageActions.FLASH_MESSAGE_SET({
                          header: 'You’re on the list',
                          subheader: `You have signed up for notifications ${title}`,
                        })
                      );
                      form.resetFields(['email']);
                    });
                }}
              >
                <Form.Item
                  rules={[
                    {
                      type: 'email',
                      message: 'Please enter a valid email',
                    },
                    {
                      required: true,
                      message: 'Please enter your email',
                    },
                  ]}
                  name="email"
                >
                  <Input
                    type="email"
                    prefix={<MailOutlined style={{ color: 'rgba(0,0,0,.25)' }} />}
                    placeholder="Email"
                  />
                </Form.Item>
                <Button type="primary" htmlType="submit">
                  Notify Me
                </Button>
              </Form>
            </div>
          </div>
          <div>
            <img className={styles.heroImg} src={thumbnail} />
            <p className={styles.summary}>{summary}</p>
          </div>
        </section>
      )}
    </>
  );
};
